import React from 'react';
import { useTranslation } from 'react-i18next';

const DownloadButton = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <button type={'button'} className={'button-default download-button'} onClick={onClick}>
      {t('download').toUpperCase()}

      <span className={'icon-download-group'}>
        <i className={'icon icon-download'} />
      </span>
    </button>
  );
};

export default DownloadButton;
